export default __webpack_public_path__ + "static/media/shopBagGray.834821eb.svg";